import { styled } from 'styled-components';
import { Input, Modal, Select, Tabs } from 'antd';

export const DisplayNavWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  .ant-form-item-control-input {
    top: 12px;
  }
`;
export const DisplayNavContent = styled.div`
  display: flex;
  justify-content: space-between;
  width: 95%;
  @media screen and (max-width: 1450px) {
    display: flex;
    justify-content: center;
    flex-direction: column-reverse;
  }
`;

export const SearchBar = styled(Input)`
  width: 160px;
  height: 40px;
  border-color: #d4d4d4;
  border-width: 1px;
  border-style: solid;
  border-radius: 5px;
  background: #ffffff;
  margin-right: 20px;
  @media screen and (max-width: 1290px) {
    width: 200px;
  }
  @media screen and (max-width: 562px) {
    width: 290px;
  }
`;
export const TabBar = styled(Tabs)`
  background-color: inherit;
  color: var(--topmenu-text-color);
  margin-left: 20px;
  border: none;
  font-weight: bold;
  path {
    fill: var(--topmenu-text-color);
  }
  .ant-tabs-ink-bar.ant-tabs-ink-bar-animated {
    background: var(--topmenu-highlighter-color) !important;
  }
  .ant-tabs .ant-tabs-tab {
    font-size: 16px;
  }
  & .ant-tabs-nav::before {
    visibility: hidden !important;
  }
  .ant-tabs-tab-active {
    color: var(--topmenu-active-color) !important;
    path {
      fill: var(--topmenu-active-color);
    }
    .ant-tabs-tab-btn {
      color: var(--topmenu-active-color) !important;
    }
  }
  .ant-tabs-tab-btn:hover {
    color: var(--topmenu-hover-color) !important;
    path {
      fill: var(--topmenu-hover-color);
    }
  }
`;
export const MenuBarWrap = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  flex: 1;
  flex-wrap: wrap-reverse;
  @media screen and (max-width: 470px) {
    flex-direction: column-reverse;
  }
`;

export const FilterSelect = styled(Select)`
  .ant-select-selector {
    min-width: 140px;
    height: 40px !important;
  }
  .ant-select-selection-item {
    align-self: center;
  }
`;

export const NavBarButtonWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  @media screen and (max-width: 546px) {
    flex-wrap: wrap;
  }
`;
export const ImportUserModal = styled(Modal)`
  .ant-upload.ant-upload-select {
    margin-top: 10px;
    text-align: center;
  }
  .ant-btn.create-button {
    height: 100px;
    width: 200px;
    border: 1px solid cadetblue;
    font-size: 20px;
  }
  .ant-upload {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
`;
